import { useApiPvpApplicationsSectionsList } from "@/api/lctApIComponents";
import { useAppSelector } from "@/hooks/reduxHooks";

export const useSections = (appId?: string, pvpId?: string) => {
  const token = useAppSelector((state) => state.user.authKey);

  const { data: sections, refetch } = useApiPvpApplicationsSectionsList(
    { headers: { Authorization: `Token ${token}` }, pathParams: { app: appId ?? "", pvp: pvpId ?? "" } },
    { enabled: !!appId && !!pvpId },
  );

  const getSectionTitle = (sectionId: string | null | undefined) => {
    const section = sections?.results?.find((section) => section.id === sectionId);
    return section?.header_text ?? undefined;
  };

  return { sections, getSectionTitle, refetch };
};
